// extracted by mini-css-extract-plugin
export var animationContainer = "_fe-0";
export var asteriskIcon = "_fe-8";
export var conversationLeftSection = "_fe-4";
export var conversationListItem = "_fe-3";
export var conversationMiddleSection = "_fe-5";
export var conversationRightSection = "_fe-6";
export var detailsContent = "_fe-1";
export var listContainer = "_fe-7";
export var modalContent = "_fe-2";